import React from "react";
import Buttons from "./../../components/buttons/buttons";
import "./scss/project-management.scss";

export default function ViewStage(props) {
  const { viewData, parentStageId } = props;
  const writePermission = props.userAccessControl === 2 ? true : false;

  return (
    <div>
      <p>
        <span>Section Name:</span> {viewData.name}
      </p>
      <p>
        <span>Description:</span> {viewData.description}
      </p>
      <p>
        <span>Total Cost of Section:</span> ${viewData.totalCost}
      </p>
      {/* <p><span>Profit Margin:</span> {viewData.profitMargin}</p> */}
      <p>
        <span>No of tasks:</span> {viewData.totalTasks}
      </p>
      <div className="editStage">
        {writePermission && (
          <Buttons
            className="cancel-btn"
            title={parentStageId ? "Edit Sub-Section" : "Edit Section"}
            onClick={props.editHandler}
          />
        )}
      </div>
    </div>
  );
}
